import axios from 'axios'
import './debug.js' // 引入调试工具


// 创建axios实例
const api = axios.create({
  // 开发环境使用代理，生产环境使用完整URL
  //baseURL: 'http://127.0.0.1:48082',
  //baseURL: 'http://122.224.62.138:48082',
  baseURL: 'https://api.zjgzaj.com',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
api.interceptors.request.use(
  config => {
    // 可以在这里添加token等认证信息
    // const token = localStorage.getItem('token')
    // if (token) {
    //   config.headers.Authorization = `Bearer ${token}`
    // }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
api.interceptors.response.use(
  response => {
    const { data } = response
    // 根据你提供的接口格式，code为0表示成功
    if (data.code === 0) {
      return data
    } else {
      // 处理业务错误
      console.error('API Error:', data.msg || '请求失败')
      return Promise.reject(new Error(data.msg || '请求失败'))
    }
  },
  error => {
    console.error('Network Error:', error.message)
    return Promise.reject(error)
  }
)

// 网站类别
export const getWebsiteType = (params = {}) => {
  return api.get('/admin-api/system/website-type/list', {
    params: {
      ...params
    }
  })
}

// 网站信息公开数据接口
export const getWebsiteData = (params = {}) => {
  return api.get('/admin-api/system/website/page', {
    params: {
      pageNo: 1,
      pageSize: 12,
      status:0,
      ...params
    }
  })
}

export default api
